define('datakit/mixin/child.models.mixin',['require','exports','module','underscore','backbone','backbone.radio','../collection'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Radio = require('backbone.radio');
  var DKCollection = require('../collection');

  var ChildModelsMixin = {

    childModels: {},

    initializeMixin: function(attrs, options) {
      options = options || {};
      var childModels = _.extend({}, this.childModels, options.childModels);

      var modelsChannel = Radio.channel('models');

      this.childModels = {};

      _.each(childModels, function(type, key) {
        var ctor;
        if (_.isString(type)) {
          ctor = modelsChannel.request(type);
          if (!ctor) {
            throw new Error("The model of type \"" + type + "\" for key \"" + key + "\" does not exist.  You may need to include it.");
          }
        } else if (_.isFunction(type)) {
          ctor = type;
        } else {
          throw new Error("Unknown Model type for key \"" + key + "\"");
        }

        this.childModels[key] = ctor;
        this.registerSetter(key, this._setChildEntity);
        this.registerCloner(key, this._cloneChildEntity);
        this.registerSerializer(key, this._serializeChildEntity);
      }, this);

      this.registerSetter(function(attr, options) {
        return _.has(options, 'modelClass');
      }, this._setChildEntity);

      this.on('create:child', function(self, attr, entity, options) {
        entity._parent = self;
        entity._parentKey = attr;
      });
    },

    eachChildResource: function(fn, context) {
      _.each(this.childModels, function(ctor, name) {
        if (this.get(name) && _.isFunction(fn)) {
          fn.call(context || this, this.get(name), name);
        }
      }, this);
      return this;
    },

    _setChildEntity: function(attr, value, options) {
      this.setWithModelClass(attr, value, options.modelClass || this.childModels[attr], options);
    },

    setWithModelClass: function(attr, value, ModelClass, options) {
      var entity;

      if (this._isArrayOrCollection(value)) {
        entity = this._setArrayWithModelClass(attr, value, ModelClass, options)
      } else if (_.isObject(value)) {
        entity = this._setObjectWithModelClass(attr, value, ModelClass, options);
      } else {
        entity = value;
      }

      this._set(attr, entity);

      return entity;
    },

    _setArrayWithModelClass: function(attr, value, ModelClass, options) {
      var currentValue             = this.get(attr),
          valueIsCollection        = (value instanceof Backbone.Collection),
          currentValueIsCollection = (currentValue instanceof Backbone.Collection);

      if (valueIsCollection) {
        // replace pathway
        currentValue = value;
      } else if (currentValueIsCollection) {
        // update pathway
        currentValue.set(value, options);
      } else {
        // create pathway
        currentValue = new DKCollection(value, { model: ModelClass });
        currentValue._parent = this;
        this.trigger('create:child', this, attr, currentValue, options);
        this.trigger('create:child:' + attr, this, currentValue, options);
        this._initializeChildEntityEvents(attr, currentValue, options);
      }

      return currentValue;
    },

    _setObjectWithModelClass: function(attr, value, ModelClass, options) {
      var currentValue        = this.get(attr),
          valueIsModel        = (value instanceof Backbone.Model),
          currentValueIsModel = (currentValue instanceof Backbone.Model),
          idAttribute         = ModelClass.prototype.idAttribute;

      if (valueIsModel && currentValueIsModel) {
        // merge model pathway
        currentValue = this._mergeModels(currentValue, value, options);
      } else if (valueIsModel) {
        // replace model pathway
        currentValue = value;
      } else {
        var canUpdateCurrentValue = true;
        if (currentValueIsModel) {
          var idValue = _.result(value, idAttribute);
          if (idValue && currentValue.id && idValue != currentValue.id) {
            // they have conflicting ids so we
            // are efftively using a new model
            canUpdateCurrentValue = false;
          }
        }
        if (currentValueIsModel && canUpdateCurrentValue) {
          // update model pathway
          currentValue.set(value, options);
        } else {
          //create model pathway
          currentValue = new ModelClass(value);
          currentValue._parent = this;
          this.trigger('create:child', this, attr, currentValue, options);
          this.trigger('create:child:' + attr, this, currentValue, options);
          this._initializeChildEntityEvents(attr, currentValue, options);
        }
      }

      return currentValue;
    },

    _isArrayOrCollection: function(value) {
      return _.isArray(value) || (value instanceof Backbone.Collection);
    },

    _mergeModels: function(currentModel, newModel, options) {
      var haveSameIds = (newModel.id != null && newModel.id == currentModel.id);
      if (haveSameIds) {
        currentModel.set(newModel.attributes, options);
        return currentModel;
      }
      return newModel;
    },

    _initializeChildEntityEvents: function(attr, entity, options) {
      // listen for changes on the entity that we are setting
      // so that we can know when it changes
      this.on('change:' + attr, function(self, value) {
        if (value !== entity) {
          if (entity._parent === this) {
            entity._parent = null;
          }
          this.trigger('before:destroy:child', this, attr, entity, options);
          this.trigger('before:destroy:child:' + attr, this, entity, options);
          this.stopListening(entity);
          this.trigger('destroy:child', this, attr, entity, options);
          this.trigger('destroy:child:' + attr, this, entity, options);
        }
      }, this);
      this.listenTo(entity, 'change', function(m, options) {
        this.trigger('change:' + attr, this, entity, options);
        this.trigger('change', this, options);
      });
      if (entity instanceof Backbone.Collection) {
        this.listenTo(entity, 'update', function(m, options) {
          this.trigger('change:' + attr, this, entity, options);
          this.trigger('change', this, options);
        });
      }
    },

    _cloneChildEntity: function(attr, value) {
      if (value instanceof Backbone.Model) {
        return value.clone();
      } else if (value instanceof Backbone.Collection) {
        return value.map(function(model) {
          return model.clone();
        });
      }
      return value;
    },

    _serializeChildEntity: function(attr, model, options) {
      if (model instanceof Backbone.Model) {
        return this.serializeChildModel(model, options);
      } else if (model instanceof Backbone.Collection) {
        return model.map(function(m) {
          return this.serializeChildModel(m, options);
        }, this);
      }
      return model;
    },

    serializeChildModel: function(model, options) {
      // we want the idAttribute and any nested models
      var keys = _.keys(model.childModels).concat([model.idAttribute]);
      return _.pick(model.toJSON(options), keys);
    }

  };

  module.exports = ChildModelsMixin;
});

